import React, { useState } from 'react'
import styled from 'styled-components'

import { Helmet } from 'react-helmet'
import { NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom'
import {
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'
import { Add as AddIcon, CloudDownload as MuiCloudDownload } from '@material-ui/icons'

import {
  useQueryPaginator,
  DateField,
  LinkedField,
  PaginatedTable,
  ShipmentStatusField,
  ValueField,
} from 'src/components/Table'
import { ASNDialog } from 'src/modules/client/components/ASNDialog'

import { skuit } from 'src/services/skuit'
import { ExportDialog } from 'src/components/Dialog'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

const CloudDownload = styled(MuiCloudDownload)(spacing)
const Divider = styled(MuiDivider)(spacing)

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)

export const ASNListPage = () => {
  const [ASNDialogOpen, setASNDialogOpen] = useState(false)
  const [exportOpen, setExportOpen] = useState(false)
  const paginator = useQueryPaginator('asn-list', skuit.client.asn.list)

  return (
    <React.Fragment>
      <Helmet title="Advanced Shipping Notices" />
      {ASNDialogOpen && (
        <ASNDialog
          open={ASNDialogOpen}
          handleClose={() => {
            setASNDialogOpen(false)
          }}
          onSave={paginator.refresh}
        />
      )}

      <Grid justify="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Advanced Shipping Notices
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/">
              Dashboard
            </Link>
            <Typography>Advanced Shipping Notices</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item>
          <div>
            <Button variant="contained" color="primary" onClick={() => setASNDialogOpen(true)}>
              <AddIcon />
              New Advanced Shipping Notice
            </Button>
          </div>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Button variant="contained" onClick={() => setExportOpen(true)}>
            <CloudDownload mr={2} /> Export ASNs to CSV
          </Button>
        </Grid>
        <Grid item xs={12}>
          <PaginatedTable
            title="Advanced Shipping Notices"
            fields={[
              { id: 'trackingNumber', label: 'Tracking Number', renderer: LinkedField(ValueField) },
              { id: 'consignee', label: 'Consignee', renderer: ValueField },
              { id: 'facility.name', label: 'Facility', renderer: ValueField },
              { id: 'carrier.name', label: 'Carrier', renderer: ValueField },
              { id: 'status', label: 'Status', renderer: ShipmentStatusField },
              { id: 'estimatedArrivalDate', label: 'Estimated Arrival Date', renderer: DateField },
              { id: 'receivedOn', label: 'Received On', renderer: DateField },
            ]}
            paginator={paginator}
          />
        </Grid>
      </Grid>
      <ExportDialog
        name="ASNs"
        download={skuit.client.asn.export}
        open={exportOpen}
        fields={[
          'bill_of_lading_number',
          'canceled_on',
          'carrier_guid',
          'carrier_name',
          'facility_address',
          'facility_guid',
          'facility_name',
          'guid',
          'is_transload',
          'received_on',
          'status',
          'tracking_number',
        ]}
        handleClose={() => setExportOpen(false)}
      />
    </React.Fragment>
  )
}
